import React, { useEffect, useState } from 'react'
import { Descriptions, Divider, message } from '@convertlab/c-design'
import Code from './Code'
import DataTable from './Table'

const DataRender = (props) => {
  const { path } = props
  const [data, setData] = useState(null)

  const getColumn = (type = true, required = true) =>
    [
      {
        title: '参数',
        dataIndex: 'name',
        width: 250,
      },
      type && {
        title: '类型',
        dataIndex: 'type',
        width: 120,
      },
      required && {
        title: '必填',
        dataIndex: 'required',
        width: 100,
        render: (value) => <span>{value ? '是' : '否'}</span>,
      },
      {
        title: '描述',
        dataIndex: 'description',
        render: (value) => <span dangerouslySetInnerHTML={{ __html: value }} />,
      },
    ].filter(Boolean)

  useEffect(() => {
    fetch(path)
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((error) =>
        message.error(`获取 ${path} 路径下的数据失败：${error.message}`, 5000)
      )
  }, [])

  if (!data) {
    return null
  }

  const {
    summary,
    permission,
    calllimit,
    method = '',
    url = '',
    allParams,
  } = data
  const examples = data.examples || []

  return [
    summary && [
      <span key="description" dangerouslySetInnerHTML={{ __html: summary }} />,
      <Divider key="divider" />,
    ],
    <Descriptions column={1} colon={false} key="descriptions">
      {permission?.name && (
        <Descriptions.Item label="权限说明">
          需要获取 <a href="/restapi/permissionscopes">{permission.name}</a>{' '}
          权限
        </Descriptions.Item>
      )}
      {calllimit && calllimit !== '通用' && (
        <Descriptions.Item label="调用频次">{calllimit}</Descriptions.Item>
      )}
      <Descriptions.Item label="请求方式">
        {method} {url}
      </Descriptions.Item>
      {examples.map((example, index) => [
        <Descriptions.Item
          key="example.summary"
          label={`请求示例${examples.length > 1 ? index + 1 : ''}`}
          className="ant-descriptions-item-block ant-descriptions-item-mark"
        >
          {example.summary && (
            <span dangerouslySetInnerHTML={{ __html: example.summary }} />
          )}
        </Descriptions.Item>,
        <Descriptions.Item
          key="example.params"
          label="请求地址"
          className="ant-descriptions-item-block"
        >
          <Code
            languages="text"
            code={
              example.params ? `${url}&${example.params}` : `${method} ${url}`
            }
          />
          {example?.description?.params?.length && (
            <DataTable
              columns={getColumn(false)}
              dataSource={example.description.params}
            />
          )}
        </Descriptions.Item>,
        example.requestBody && (
          <Descriptions.Item
            key="example.requestBody"
            label="请求体参数"
            className="ant-descriptions-item-block"
          >
            <Code languages="json" code={example.requestBody} />
            {example?.description?.requestBody?.summary && (
              <span
                dangerouslySetInnerHTML={{
                  __html: example.description.requestBody.summary,
                }}
              />
            )}
            {(example?.description?.requestBody?.refs?.length ||
              example?.description?.requestBody?.fields?.length) && (
              <DataTable
                key="requestBody.fields"
                columns={getColumn()}
                refs={example.description.requestBody.refs}
                fields={example.description.requestBody.fields}
              />
            )}
          </Descriptions.Item>
        ),
        example.responseBody && (
          <Descriptions.Item
            key="example.responseBody"
            label={`返回示例${examples.length > 1 ? index + 1 : ''}`}
            className="ant-descriptions-item-block"
          >
            <Code languages="json" code={example.responseBody} />
            {example?.description?.responseBody?.summary && (
              <span
                dangerouslySetInnerHTML={{
                  __html: example.description.responseBody.summary,
                }}
              />
            )}
            {(example?.description?.responseBody?.refs?.length ||
              example?.description?.responseBody?.fields?.length) && (
              <DataTable
                columns={getColumn(true, false)}
                refs={example.description.responseBody.refs}
                fields={example.description.responseBody.fields}
              />
            )}
          </Descriptions.Item>
        ),
        example.errorResponse && (
          <Descriptions.Item
            key="example.errorResponse"
            label={`失败示例${examples.length > 1 ? index + 1 : ''}`}
            className="ant-descriptions-item-block"
          >
            <Code languages="json" code={example.errorResponse} />
          </Descriptions.Item>
        ),
        example?.failureCodes?.length && (
          <Descriptions.Item
            key="example.failureCodes"
            label="错误码列表"
            className="ant-descriptions-item-block ant-descriptions-item-mark"
          >
            <DataTable
              rowKey="code"
              columns={[
                {
                  title: '错误码',
                  dataIndex: 'code',
                },
                {
                  title: '描述',
                  dataIndex: 'description',
                },
              ]}
              fields={example.failureCodes}
            />
          </Descriptions.Item>
        ),
      ])}
      {allParams && [
        <Descriptions.Item
          key="allParams.summary"
          label="接口参数统一说明"
          className="ant-descriptions-item-block ant-descriptions-item-mark"
        >
          {allParams.summary && (
            <p dangerouslySetInnerHTML={{ __html: allParams.summary }} />
          )}
        </Descriptions.Item>,
        allParams?.params?.length && (
          <Descriptions.Item
            key="allParams.params"
            label="请求参数说明"
            className="ant-descriptions-item-block"
          >
            <DataTable columns={getColumn(false)} fields={allParams.params} />
          </Descriptions.Item>
        ),
        (allParams?.refs?.length || allParams?.fields?.length ) && (
          <Descriptions.Item
            key="allParams.refs"
            label="请求/返回体参数说明"
            className="ant-descriptions-item-block"
          >
            <DataTable
              columns={getColumn()}
              refs={allParams.refs}
              fields={allParams.fields}
            />
          </Descriptions.Item>
        ),
        allParams?.failureCodes?.length && (
          <Descriptions.Item
            key="allParams.failureCodes"
            label="错误码列表"
            className="ant-descriptions-item-block ant-descriptions-item-mark"
          >
            <DataTable
              rowKey="code"
              columns={[
                {
                  title: '错误码',
                  dataIndex: 'code',
                },
                {
                  title: '描述',
                  dataIndex: 'description',
                },
              ]}
              fields={allParams.failureCodes}
            />
          </Descriptions.Item>
        ),
      ]}
    </Descriptions>,
  ]
}

export default DataRender
